import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

const propTypes = {
	updateIsDispOgImage: PropTypes.func
};

class Step2 extends React.Component {

	//チェックボックスを押下時に親コンポーネントを呼び出す
	handleChangeIsDispOgImage(event){
		console.log(event.target.checked)
		return this.props.updateIsDispOgImage(event.target.checked);
	};

	//セレクトボックス変更時に親コンポーネントを呼び出す
	handleUpdateDispSearchNum(event){
		console.log(event.target.value)
		return this.props.updateDispSearchNum(event.target.value);
	};

	render() {

		//セレクトボックス
		const items = [
			{ value: '10', disp: '10件-速い' },
			{ value: '20', disp: '20件' },
			{ value: '30', disp: '30件' },
			{ value: '40', disp: '40件' },
			{ value: '50', disp: '50件-遅い' },
		];

		let selectList = []
				
		//セレクトボックスの設定
		for(let i=0; i < items.length; i++){
			if(this.props.dispSearchNum == items[i].value){
				selectList.push(<option value={items[i].value} selected>{items[i].disp}</option>)
			}else{
				selectList.push(<option value={items[i].value}>{items[i].disp}</option>)
			}
		}

		return (
			<div id="contents_body">
				<p>
					検索結果の表示内容を設定します。
				</p>
				<form className="attention-box-option">
					<FormControlLabel
						control={
							<Checkbox
								checked={this.props.isDispOgImage}
								onChange={(event) => { this.handleChangeIsDispOgImage(event) }}
								name="checkedB"
								size="small"
								style ={{
									color: "black",
								}}
							/>
						}
						label="og:imageによる画像を表示"
					/>
				</form>
				<label className="lbl-img-quality">
					<div className="dispSearchNum">
						<span>
							デフォルトの検索結果の表示件数
						</span>
						<div className="select-wrap">
							<select id="selectSearchNum" name="selectSearchNum" onChange={(event) => { this.handleUpdateDispSearchNum(event)}}>
								{selectList}
							</select>
						</div>
					</div>
				</label>
			</div>
		);
	}
}

export default Step2;